

import React from 'react'
import getAirportInfo from './getAirportInfo'
import { string, objectOf, shape } from 'prop-types'

const breadcrumbType = shape({
  text: string,
  page: string
})

class Breadcrumb extends React.Component {

  convertPageToText (page) {
    return page.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  getCrumbs () {
    const { pageName, breadcrumb } = this.props
    if (breadcrumb) return this.makeCrumbs(breadcrumb)
    if (!pageName) return null
    return this.convertPageToCrumbs(pageName)
  }

  convertPageToCrumbs (pageName) {
    const crumbs = pageName.split('.')[0].split('/')
    return this.makeCrumbs(crumbs.map(page => {
      const text = this.convertPageToText(page)
      return {
        text,
        page
      }
    }))
  }

  makeCrumbs (crumbs) {
    let trail = ''
    const lastPage = crumbs[ Object.keys(crumbs).pop() ].page
    return Object.keys(crumbs).map((crumbItem, key) => {
      const crumb = crumbs[crumbItem]
      // page your on
      if (!crumb.page || crumb.page === lastPage) return (<li key={key}>{ crumb.text }</li>)
      trail += '/' + crumb.page
      let url = trail
      const location = getAirportInfo(url)
      if (location && crumb.text.toLowerCase() === location.pattern.toLowerCase()) {
        url = '/' + crumb.text.toLowerCase()
        if (trail.match('port-parking') && !trail.match('airport-parking')) url += '-port-parking'
        if (trail.match('port-hotels') && !trail.match('airport-hotels')) url += '-port-hotels'
        if (trail.match('airport-parking')) url += '-airport-parking'
        if (trail.match('airport-hotels')) url += '-airport-hotels'
        if (trail.match('airport-lounges')) url += '-airport-lounges'
      }
      return (
        <li key={key}>
          <a className='link' href={url + '.html'} title={crumb.text}>{ crumb.text }</a>
        </li>
      )
    })
  }

  render () {
    const { homeLink, homeText } = this.props
    const crumbs = this.getCrumbs()
    return (
      <ul className='breadcrumb'>
        <li className='home'>
          <a className='link' href={homeLink}><i className='icon-home' />{ homeText }</a>
        </li>
        { crumbs }
      </ul>
    )
  }
}

Breadcrumb.propTypes = {
  pageName: string,
  breadcrumb: objectOf(breadcrumbType),
  homeLink: string,
  homeText: string
}

Breadcrumb.defaultProps = {
  homeLink: '/',
  homeText: 'Home'
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/breadcrumb.jsx